import { getEmployeeFields } from "components/user/config";
import { addItemToCollection } from "directus/src/operations";

export async function createTask({ item }) {
  try {
    const query = {
      fields: [
        "id",
        "title",
        "status",
        "type",
        "description",
        "due_date",
        "date_created",
        getEmployeeFields("assignee"),
        "attachments.file.id",
        "attachments.file.type",
        "attachments.file.filename_download",
      ],
    };

    const data = await addItemToCollection("tasks", item, query);

    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
}
